import { useDispatch } from "react-redux"
import { Route, Routes, useNavigate } from "react-router-dom"
import { setBankVariant } from "../../../../store/slices/settingsSBP"

import BankSelection from "../../../../pages/BankSelection"

import { useAddBankPermission } from "../../../../api/hooks/useAddBankPermission"
import { ROUTES_PATHS } from "../../../../utils/constants"

import {
  IBankMeta,
  BankRole,
  BankScenario,
} from "../../../../api/interface"

const SettingsAllowedBanksFlow = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { mutate: addPermission } = useAddBankPermission()

  const bankSelectDescription =
    "Выберите свой банк на который будут автоматически списываться средства по запросу"

  const handleBankClick = async (bank: IBankMeta) => {
    await addPermission(bank.bankId)
    dispatch(setBankVariant(bank))
    navigate(`/${ROUTES_PATHS.settingsSBP}`)
  }

  return (
    <Routes>
      <Route
        index
        element={
          <BankSelection
            handleBankClick={handleBankClick}
            bankSelectDescription={bankSelectDescription}
            showFooter
            role={BankRole.SENDER}
            scenario={BankScenario.M2M_PULL}
          />
        }
      />
    </Routes>
  )
}

export default SettingsAllowedBanksFlow
